import { Conn_Db } from '../models/datapoint/conn_db';
import { RepConnWrapper } from 'src/app/modules/repconn/repconn.wrapper';
import { ObjectWrapper } from '../wrappers/object.wrapper';
import { SessionFactory } from '../caches/session.factory';
import { ErrorCdsEnums } from '../errorcds.enums';

export class Util {
    private static instance: Util;

    static getInstance() {
        if (!Util.instance) {
            Util.instance = new Util();
        }
        return Util.instance;
    }

    /**
     * Util is a singleton class, so use Util.getInstance() method instead of creating new Util().
     */
    private constructor() {

    }

    getValid_Msg(valid_Cd: string): string {
        if (valid_Cd == "0") return "";

        let valid_Msg: string = ErrorCdsEnums.errorcds[valid_Cd];
        if (valid_Msg) return valid_Msg;

        return valid_Cd;
    }

    getObjectNameByCode(obj_Cd: string): string {
        switch (obj_Cd) {
            case "DOBJ": return "Data Object";
        }
        return "";
    }

    splice(list: Array<any>): void {
        if (list.length > 0) {
            list.splice(0, list.length);
        }
    }

    /**
     * value: 'abc_aa' 
     * names: ['abc' 'abc_1', 'aaa', 'abc_aa']
     * return 'abc_aa_1'
     */
    getNewName(value: string, names: Array<string>, parent_Attr_IdString: string = '', index: number = -1) {
        let valueUC = parent_Attr_IdString + value.toUpperCase();

        if (index == -1) {
            if (names.indexOf(valueUC) == -1)
                return value;

            let _index = value.lastIndexOf('_');
            if (_index == -1) {
                return this.getNewName(value + '_', names, parent_Attr_IdString, 1);
            }

            let _afterString = value.substr(_index + 1, value.length);
            if (isNaN(parseInt(_afterString))) {
                return this.getNewName(value + '_', names, parent_Attr_IdString, 1);
            }

            return this.getNewName(value.substr(0, _index + 1), names, parent_Attr_IdString, 1);
        } else {
            if (names.indexOf(valueUC + index) == -1) {
                let name = value + index;
                let check: boolean = names.includes(name);
                if (check == true)
                    return this.getNewName(value, names, parent_Attr_IdString, index + 1);
                return name;
            }
            return this.getNewName(value, names, parent_Attr_IdString, ++index);
        }
    }

    getPageNo(index: number, noOfRowsPerPage: number): number {
        return Math.ceil(index / noOfRowsPerPage);
    }

    rename(value: string, replaceRegExp: any, replaceWith: string, oldFullName: string = '') {
        return value.replace(replaceRegExp, replaceWith);
    }

    updateName(objectWrapper: ObjectWrapper): void {
        if (!objectWrapper) return;

        let paramValue: string
        if (objectWrapper.databaseWrapper)
            paramValue = '$' + objectWrapper.code + '_' + SessionFactory.getInstance().fldr.fldr_Cd + '_' + objectWrapper.databaseWrapper.code + '_' + objectWrapper.aliasNm + '_' + objectWrapper.name;
        else
            paramValue = '$' + objectWrapper.code + '_' + SessionFactory.getInstance().fldr.fldr_Cd + '_' + objectWrapper.aliasNm + '_' + objectWrapper.name;

        objectWrapper.setParamNm(paramValue.toUpperCase());
    }

    updateDbParamNm(repConnWrapper: RepConnWrapper, conn_Db: Conn_Db): string {
        if (!repConnWrapper ||
            !conn_Db) return "";

        let dbParamNm: string = "$DB_" + repConnWrapper.databaseWrapper.code + "_" +
            repConnWrapper.aliasNm + "_" + repConnWrapper.name + "_" + conn_Db.nm;

        return dbParamNm.toUpperCase();
    }

    updateSchemaParamName(repConnwrapper: RepConnWrapper, conn_Db: Conn_Db) {
        if (!repConnwrapper || !conn_Db) return;

        let schemaParamNm: string = '$SC' + '_' + repConnwrapper.databaseWrapper.code + '_' +
            repConnwrapper.aliasNm + '_' + repConnwrapper.name + '_' +
            conn_Db.nm + "_" + conn_Db.schemaNm;

        return schemaParamNm.toUpperCase();
    }

    addSubName(subName: string, objectWrapper: ObjectWrapper, parent_Attr_Id: number = -1): void {
        if (parent_Attr_Id != -1) {
            subName = parent_Attr_Id + subName.toUpperCase();
        }

        if (objectWrapper.subNames.indexOf(subName) != -1) return;

        objectWrapper.subNames.push(subName);
    }

    addSub_Id(conn_Db_Id, conn_Db: Conn_Db, repConnWrapper: RepConnWrapper) {

        // if (repConnWrapper.conn_Db_IdsMap[conn_Db_Id]) return;

        // repConnWrapper.conn_Db_IdsMap[conn_Db_Id] = conn_Db;
    }



    readDotStringNotation(obj, dotString) {
        if (typeof dotString == 'string')
            return this.readDotStringNotation(obj, dotString.split('.'));

        if (dotString.length == 1)
            return obj[dotString[0]];

        if (dotString.length == 0) return obj;

        return this.readDotStringNotation(obj[dotString[0]], dotString.slice(1));
    }






    isEmpty(value) {
        return value = null; //value == '';
        // return angular.isUndefined(value) || value === '' || value === null || value !== value;
    }


    getMvw_Entity_LineageString(mvw_Entity_Lineage) {
        return mvw_Entity_Lineage.entity_Id + '.' + mvw_Entity_Lineage.lnk_Entity_Id;
    }



    getConn_Db_Obj_LnkKey(Conn_Db_Obj_Lnk) {
        return Conn_Db_Obj_Lnk.dxFlow_Id + "-" + Conn_Db_Obj_Lnk.dxMp_Inst_Id + "-" + Conn_Db_Obj_Lnk.obj_Id;
    }

    getVennGroupKey(vennGrpAttr) {
        return vennGrpAttr.venn_Grp_Id + "-" +
            vennGrpAttr.lnk_Attr_Id + "-" +
            vennGrpAttr.lnk_Obj_Id + "-" +
            vennGrpAttr.venn_Inst_Id + "-" +
            vennGrpAttr.dxMp_Id + "-" +
            vennGrpAttr.srt_Order;
    }


    getDxFlow_Fwd_LnkString(dxFlow_Fwd_Lnk) {
        return dxFlow_Fwd_Lnk.obj_Id + '.' + dxFlow_Fwd_Lnk.fwd_Lnk_Obj_Id;
    }

    getLAttributeNames(lAttributes) {
        let names = [];
        for (let i = 0; i < lAttributes.length; i++) {
            names.push(lAttributes[i].lAttrNm);
        }
        return names;
    }

    getAttributeNames(attributes) {
        let names = [];
        for (let i = 0; i < attributes.length; i++) {
            names.push(attributes[i].attrNm);
        }
        return names;
    }

    getAttrDTyp_Id(object) {
        if (object.hasOwnProperty('attr_Id'))
            return object.attrDTyp_Id;
        else if (object.hasOwnProperty('param_Id'))
            return object.paramDTyp_Id;

        return 0;
    }

    validateObj_Id(obj_Id) {
        return !(obj_Id == "" || obj_Id == undefined || obj_Id == null || obj_Id == -1);
    }

    isEmptyObject(object) {
        for (let key in object) {
            if (object.hasOwnProperty(key)) return false;
        }

        return true;
    }

    hasObj_Id(obj_Id): boolean {
        return !(obj_Id == "" || obj_Id == null || obj_Id == -1);
    }

    hasLengthInHMapArray(array: Array<any>): boolean {
        for (let key in array) {
            return true;
        }

        return false;
    }

    toStringHMap(array) {
        let string = '';
        for (let key in array) {
            string += key + ': ' + array[key] + ', ';
        }
        return string;
    }

    pushItems(items1, items2) {
        let i = items2.length;
        while (i) {
            i--;
            items1.push(items2[i]);
        }
    }

    unshiftItems(items1, items2) {
        let i = items2.length;
        while (i) {
            i--;
            items1.unshift(items2[i]);
        }
    }

    assignDotStringNotation(obj, dotString, value) {
        if (typeof dotString == 'string')
            return this.assignDotStringNotation(obj, dotString.split('.'), value);

        if (dotString.length == 1 &&
            value !== undefined)
            return obj[dotString[0]] = value;

        if (dotString.length == 0) return obj;

        return this.assignDotStringNotation(obj[dotString[0]], dotString.slice(1), value);
    }

    isTabModified(objectWrapper, currentSelectedTabCode) {
        let tabDataModified = objectWrapper.isTabDataModified(currentSelectedTabCode);
        if (tabDataModified != '') return true;

        return false;
    }

    getGlobalLabel(fldr_Id: number, parentFldr_Id: number): string {
        if (fldr_Id == parentFldr_Id) return '';

        return "(Global)";
    }

    checkSearchString(searchText: string): boolean {
        if (!searchText) return false;

        if (searchText.indexOf("\'") != -1 ||
            searchText.indexOf("\{") != -1 ||
            searchText.indexOf("\}") != -1 ||
            searchText.indexOf("\#") != -1 ||
            searchText.indexOf("\.") != -1 ||
            searchText.indexOf("\/") != -1 ||
            searchText.indexOf("\\") != -1 ||
            searchText.indexOf("\%") != -1 ||
            searchText.indexOf("\;") != -1 ||
            searchText.indexOf("\?") != -1)
            return true;

        return false;
    }

    getShortName(name: string): string {
        return name.length > 15 ? name.slice(0, 15) + '...' : name;
    }

}